import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { UButton } from "@/components/index"
import { RootState } from "@/core/app/store"
import { setIsDoingPresetup, setStageShowType, setIsCreateSelfplanRefinement, setIsCreateNewRefinement, setShowJsPreview } from "@/UDTreat/udTreatSlice"
import { uploadPhotoJSON } from "@/core/app/slices/records/photograph/photographThunkApi"
import { useParams } from "react-router-dom"
import { getCaseById, updateCaseById } from "@/core/app/slices/case/caseThunkApi"
import { setOpenReopenCaseDlg } from "../../udTreatSlice"
import { resetCase } from "@/core/app/slices/clinical/clinicalSlice"
import { fetchZipsAndLoadCase } from "@/core/app/slices/clinical/clinicalworkflow"
import { clearCache } from "@/core/app/slices/cache/cacheSlice"
export const ErrorDialogBox = (props: any) => {
  const dispatch = useAppDispatch()
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { caseId, patientId } = useParams()
  const { refinementNum } = useAppSelector((state: RootState) => state.udTreatService)
  const errorContent = (type: string) => {
    switch (type) {
      case "failed":
        return "Presetup cloud computing fails."
      case "network error":
        return "Network error, please check your network connection."
      case "retry":
        return "Some errors occurred, please try again."
    }
  }
  return (
    <DialogBox
      open={props.isShow}
      title={"Pre-setup Error"}
      content={
        <span style={{ fontSize: "14px", letterSpacing: "0.17px" }}>
          {errorContent(props.errorType)}
        </span>
      }
      actions={
        <>
          <UButton
            onClickHandler={async () => {
              props.setIsShowPresetupError(false)
              const udesign_json = JSON.parse(caseDetail.udesign_json)
              if (udesign_json.isDoingRefinePresetup) {
                dispatch(setIsCreateNewRefinement(false))
                dispatch(setIsCreateSelfplanRefinement(false))
                dispatch(setIsDoingPresetup(false))
                dispatch(setStageShowType("normal"))
                dispatch(setShowJsPreview(false))
                const newUdesignJsonObj = {
                  ...udesign_json,
                  isDoingRefinePresetup: false,
                }
                dispatch(
                  updateCaseById({
                    patientId,
                    caseId,
                    payload: {
                      case_extra_attrs: JSON.stringify(newUdesignJsonObj),
                    },
                  }),
                )
                .then(() => {
                  dispatch(getCaseById({ caseId, patientId }))
                })  
                dispatch(
                  uploadPhotoJSON({
                    caseId,
                    patientId,
                    jsonObj: null,
                    refinementIndex: refinementNum,
                    callback: () => {},
                  }),
                )
                await dispatch(setOpenReopenCaseDlg(false))
                // await dispatch(clearCache({ caseId }))
                await dispatch(resetCase())
                await dispatch(fetchZipsAndLoadCase({caseId,patientId}));
              }
            }}
            variant={"text"}
            btnText={"Cancel"}
          />
          {props.errorType !== "failed" && (
            <UButton
              onClickHandler={() => {
                props.setIsShowPresetupError(false)
                const udesign_json = JSON.parse(caseDetail.udesign_json)
                const hasUpper = udesign_json.upperUploaded
                const hasLower = udesign_json.lowerUploaded
                props.requestAiPresetup(hasUpper, hasLower, udesign_json)
              }}
              variant={"text"}
              btnText={"Retry"}
            /> 
          )}
        </>
      }
    />
  )
}
